import React, { ReactElement } from "react";
import ScoringTableCard, { ScoringTableCardProps } from "./ScoringTableCard";
import { ScoringTableDef } from "@/components/controls/DataTable/ScoringTable";
import { useScoringTable } from "./BaseScoringTableContext";

export interface ScoringTableCardLabelProps {
  title: string;
  subtitle: string;
  empty: {
    title: string;
    subtitle: string;
  };
}

export interface ScoringTableCardControllerProps {
  dataTestPrefix: string;
  labelProps: ScoringTableCardLabelProps;
  headerDataWidget: ReactElement;
  tableDef: ScoringTableDef;
  isLoading?: boolean;
}

function ScoringTableCardController({
  dataTestPrefix,
  labelProps,
  headerDataWidget,
  tableDef,
  isLoading
}: ScoringTableCardControllerProps): React.ReactElement {
  const { dynamicTableData, handleRowClick, breadcrumbIds, setSelectedUserId } =
    useScoringTable();

  const cardProps: ScoringTableCardProps = {
    dataTestPrefix,
    labelProps,
    data: dynamicTableData,
    onRowClick: handleRowClick,
    breadcrumbsNavProps: {
      title: labelProps.title,
      subtitle: labelProps.subtitle,
      ids: breadcrumbIds,
      setter: setSelectedUserId
    },
    headerDataWidget,
    tableDef,
    isLoading
  };

  return <ScoringTableCard {...cardProps} />;
}

export default ScoringTableCardController;
